import React from 'react'

import cx from 'classnames'

import s from './InnerCole.module.scss'

export default function InnerCol({ children, innerClass }) {
  return <div className={cx(s.csInner, { [innerClass]: innerClass })}>{children}</div>
}
